const phoneReg = /^1[3456789]\d{9}$/;
const mailReg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
const numberReg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/; //最多两个小数的正数
const positiveIntegerReg = /^[0-9]\d*$/; //正整数限制
const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[!"#$%&'()*+,\-.:;<=>?@\[\\\]^_`{|}~A-Za-z0-9]{8,20}$/; 

// 手机号验证
const isPositiveInteger = number => {
    return positiveIntegerReg.test(number)
};

//最多两个小数的正数验证
const isNumber = number => {
    return numberReg.test(number)
};

// 手机号验证
const isPhone = number => {
    return phoneReg.test(number)
};

// 邮箱验证
const isEmail = mail => {
    return mailReg.test(mail)
}

// 密码格式验证
const isPassword = password => {
    console.log(password)
    return passwordReg.test(password)
}

const passwordValidator = (rule, val, callback) => {
    if (isPassword(val)) {
        callback();
    } else {
        callback(new Error("密码格式不正确!密码长度为8-16位，且密码需使用大写字母、小写字母、数字及特殊字符（_~@#$^）四种字符中至少两种的组合！"));
    }
}

const numberValidator = (rule, val, callback) => {
    if (isNumber(val)) {
        callback();
    } else {
        callback(new Error("报价为最多两个小数的正数"));
    }
}

const positiveIntegerValidator = (rule, val, callback) => {
    if (isPositiveInteger(val)) {
        callback();
    } else {
        callback(new Error("正整数限制"));
    }
}

const phoneValidator = (rule, val, callback) => {
    if (isPhone(val)) {
        callback();
    } else {
        callback(new Error("填写正确的手机号码"));
    }
}
const mailValidator = (rule, val, callback) => {
    if (isEmail(val)) {
        callback();
    } else {
        callback(new Error("填写正确的邮箱"));
    }
}
const timeLoop = (timerObj, timeCount, callback) => {

    if (timeCount <= 0) {

        clearTimeout(timerObj ? timerObj.timer : '');
        timerObj.timer = null;
        timeCount = 0;
        callback && callback(0)
        return;
    }
    if (timeCount > 0) {

        timeCount -= 1;
        callback && callback(timeCount)
    }
    timerObj.timer = setTimeout(function() {
        timeLoop(timerObj, timeCount, callback);
    }, 1000)
}
module.exports = {
    isNumber,
    isPhone,
    isEmail,
    numberValidator,
    phoneValidator,
    mailValidator,
    positiveIntegerValidator,
    passwordValidator,
    timeLoop
}